import React, { useEffect } from 'react';

import {
	getPostUpgradeModalToShowForUpgradeFreePoolTargetExperiment,
	isWithinGracePeriod,
	Product,
	STORAGE_KEYS,
	type StorageAdapter,
	UpgradeModalComponent,
} from '../../utils';
import { ConfluenceAfterStandardUpgradeAIModal } from '../ConfluenceAfterStandardUpgradeAIModal';
import {
	CALENDAR_URL_STRING,
	ConfluenceAfterStandardUpgradeCalendarModal,
} from '../ConfluenceAfterStandardUpgradeCalendarModal';

export const ConfluenceUpgradeFreePoolExperimentModalPostUpgrade = ({
	storageAdapter,
	calendarUrl,
}: {
	calendarUrl?: string;
	storageAdapter: StorageAdapter;
}) => {
	const modalToShow = getPostUpgradeModalToShowForUpgradeFreePoolTargetExperiment(
		storageAdapter,
		Product.Confluence,
	);

	useEffect(() => {
		if (modalToShow !== UpgradeModalComponent.None) {
			// Check if we're within the React rerender grace period before removing storage items
			// otherwise the modal will flicker on and off the scree
			const firstModalTimestamp = storageAdapter.get(STORAGE_KEYS.Confluence.first);
			const secondModalTimestamp = storageAdapter.get(STORAGE_KEYS.Confluence.second);

			// Only remove storage items if we're not within the grace period for any existing timestamps
			const shouldRemoveItems =
				(!firstModalTimestamp || !isWithinGracePeriod(firstModalTimestamp)) &&
				(!secondModalTimestamp || !isWithinGracePeriod(secondModalTimestamp));

			if (shouldRemoveItems) {
				// Remove the experiment-related attributes from storage since we're showing the post-upgrade modal
				// This prevents the modal from showing again and cleans up experiment data
				storageAdapter.removeItem(STORAGE_KEYS.Confluence.first);
				storageAdapter.removeItem(STORAGE_KEYS.Confluence.second);
			}
		}
	}, [modalToShow, storageAdapter]);

	switch (modalToShow) {
		case UpgradeModalComponent.ConfluenceAfterStandardUpgradeAIModal:
			return <ConfluenceAfterStandardUpgradeAIModal />;
		case UpgradeModalComponent.ConfluenceAfterStandardUpgradeCalendarModal:
			return (
				<ConfluenceAfterStandardUpgradeCalendarModal
					calendarUrl={calendarUrl || CALENDAR_URL_STRING}
				/>
			);
		case UpgradeModalComponent.None:
		default:
			return null;
	}
};
